import { dateFromISOString } from '@wz-utilities/date.utilities';
import { PaymentApiModels } from 'models/api/payment-api.models';
import { PaymentModels } from 'models/payment.models';
import { projectObjectToKeyValuePair } from './common-projectors';

export function projectPaymentPayload(
  apiModel: PaymentApiModels.PayzenPayload,
): PaymentModels.PayzenPayload {
  return {
    pzProps: projectObjectToKeyValuePair(apiModel.properties),
    pzUrl: apiModel.payzenUrl,
  };
}

export function projectPaymentTransaction(
  tr: PaymentApiModels.PaymentTransaction,
): PaymentModels.PaymentTransaction {
  return {
    amount: tr.amount,
    effectiveDate: dateFromISOString(tr.effectiveDate!)!,
    id: tr.id,
    state: tr.state,
    isAccounted: tr.isAccounted,
    stateReason: tr.stateReason,
    payzenId: tr.payzenId,
  };
}
